import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_V0_VERSION_PREFIX } from "../constants/urlPaths";
import { VibesResponse } from "redmond";
import { getIframeAuthHeaders } from "../utils/sessionTokenUtil";

export const vibesApi = createApi({
  reducerPath: "vibes",
  baseQuery: fetchBaseQuery({
    baseUrl: API_V0_VERSION_PREFIX,
    prepareHeaders: (headers) => {
      Object.entries(getIframeAuthHeaders()).forEach(([key, value]) =>
        headers.set(key, value)
      );
      return headers;
    },
  }),
  tagTypes: ["Vibes"],
  endpoints: (build) => ({
    getVibes: build.query<VibesResponse, void>({
      query() {
        return {
          url: "luxury/vibes",
          method: "POST",
          body: {},
        };
      },
      providesTags: ["Vibes"],
    }),
  }),
});

export const { useGetVibesQuery } = vibesApi;
